import { LoadBlock } from '@bwoty-web/styleguide';
import './skeletonLoader.scss';

const SkeletonLoader = () => {
  return (
    <section className='vf-results-skeleton-loader'>
      <div className='vf-results-skeleton-loader-block vf-results-skeleton-loader-block__2x2'>
        <div className='vf-results-skeleton-loader-card'>
          <div className='vf-skeleton__content vf-skeleton__content--image' />
          <div className='vf-skeleton__content vf-skeleton__content--header' />
          <div className='vf-skeleton__content vf-skeleton__content--price' />
          <LoadBlock  />
        </div>
        <div className='vf-results-skeleton-loader-card'>
          <div className='vf-skeleton__content vf-skeleton__content--image' />
          <div className='vf-skeleton__content vf-skeleton__content--header' />
          <div className='vf-skeleton__content vf-skeleton__content--price' />
          <LoadBlock  />
        </div>
      </div>

      <div className='vf-results-skeleton-loader-card'>
        <LoadBlock  />
      </div>
    </section>
  )
};

export default SkeletonLoader;
